import { Box, ListItem, Paper, PaperProps, styled } from '@mui/material';

import { FullPageLoader } from '@/components/Layout/FullPageLoader';

import { elevationLevel } from '@/styles/constants/paper';

import { FileFrame } from '../../../DataDisplay/File/FileFrame';
import { ActionBar } from '../../../Layout';

export const PreQuestionsContainer = styled((props: PaperProps) => (
  <Paper elevation={elevationLevel.m} {...props} />
))(({ theme }) => ({
  borderRadius: 12,
  padding: `${theme.spacing(1.5)} ${theme.spacing(1)}`,
  alignSelf: 'stretch',

  [theme.breakpoints.up('lg')]: {
    boxShadow: 'none',
    marginTop: theme.spacing(4),
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const ConfirmQuestionsContainer = styled(PreQuestionsContainer)(() => ({
  maxWidth: 358,
  margin: `0 auto`,
  backgroundColor: 'transparent',
  boxShadow: 'none',
}));

export const QuestionItem = styled(ListItem)(({ theme, onClick }) => ({
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  cursor: onClick ? 'pointer' : 'default',
  padding: `${theme.spacing(1.5)} ${theme.spacing(1)}`,

  ':hover': {
    backgroundColor: onClick
      ? theme.palette.grey[100]
      : theme.palette.background.paper,
  },

  '.MuiListItemIcon-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    height: 40,
    width: 40,
  },

  [theme.breakpoints.up('lg')]: {
    border: `1px solid ${theme.palette.grey[500]}`,
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,

    ':not(:last-of-type)': {
      marginBottom: theme.spacing(1.5),
    },
  },
}));

export const FileSelectorContainer = styled(Box)(({ theme }) => ({
  borderRadius: 12,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',

  backgroundColor: theme.palette.grey[100],
  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23333' stroke-width='1' stroke-dasharray='4%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
  position: 'relative',
  padding: 0,
  flex: 1,
  justifyContent: 'center',
  marginTop: theme.spacing(6),

  '.MuiButton-root': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    backgroundColor: 'transparent',
    color: 'transparent',

    ':hover': {
      backgroundColor: 'transparent',
      color: 'transparent',
    },

    input: {
      width: '100%',
      height: '100%',
    },
  },
}));

export const StyledFileFrame = styled(FileFrame)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  marginTop: theme.spacing(4),
}));

export const WebView = styled('iframe')(() => ({
  flex: 1,
  width: '100%',
}));

export const DocumentLoader = styled(FullPageLoader)(({ theme }) => ({
  borderRadius: 16,
  backgroundColor: theme.palette.grey.overlayOnDark,
  color: theme.palette.common.white,
  position: 'absolute',
  left: 0,
  top: 0,
  gap: theme.spacing(3),
}));

export const DocumentCheckAction = styled(ActionBar)(({ theme }) => ({
  maxWidth: 312,
  gap: theme.spacing(1.5),
  alignSelf: 'center',
}));

export const DocumentScannerOverlay = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey.overlayOnDark,
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100dvh',
  width: '100vw',
  zIndex: theme.zIndex.drawer + 1,
}));

export const SigningDocumentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: 'fixed',
  left: 0,
  top: 0,
  height: '100dvh',
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
  zIndex: theme.zIndex.drawer + 2,
}));

export const SigningDocumentHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  height: theme.layout.headerHeight.xs,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  '.MuiTypography-root': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    minWidth: 0,
    flex: 1,
    whiteSpace: 'nowrap',
  },

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row-reverse',
  },
}));

export const BottomFixedPaper = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  borderTopLeftRadius: theme.spacing(2),
  borderTopRightRadius: theme.spacing(2),
  padding: theme.spacing(3),
}));
